import { createResource } from '../utils/resource'

const lectureStore = createResource('lecture', {})

export default lectureStore
